import React, { useEffect, useRef, useState } from 'react';
import '../../../Static/priceinfo.css';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useMediaQuery, Button } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Paper } from '@mui/material';
import ReactToPrint from 'react-to-print';
import FirmHeaderImg from '../../FieldsComponents/FirmHeaderImg';
import { fetchPOData } from '../../../Store/PHPSlice/Purchase/PoNo';
import { selectPOData } from '../../Selectors/Master/ItemSelectors';


const PurchaseOrdView = () => {
    const { Id } = useParams();
    const [formData, setFormData] = useState({});
    const dispatch = useDispatch();
    const polist = useSelector(selectPOData);
    const isDesktop = useMediaQuery('(min-width:768px)');
    const componentRef = useRef();
    useEffect(() => {
        dispatch(fetchPOData(Id))
    }, [Id, dispatch]);


    useEffect(() => {
        if (polist?.data) {
            setFormData(polist?.data);
        }
    }, [polist]);

    // console.log(formData);
    const tableContainerStyle = {
        marginLeft: isDesktop ? '5%' : '0%',
        width: isDesktop ? '90%' : '100%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none'
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',  // Ensure the x-axis scrollbar is visible
        overflowY: 'hidden', // Hide the y-axis scrollbar
        WebkitOverflowScrolling: 'touch', // Enable smooth scrolling on iOS
    };
    // console.log(polist)

    return (
        <>
            <Grid item xs={12}>
                <Paper style={{ padding: '3vh', margin: '0' }}>
                    <div style={{ margin: '1%', width: '100%' }} ref={componentRef}>
                        {formData?.firmId !== '' && <FirmHeaderImg firmId={formData.firmId} />}
                        <h3 className='centered-heading'>Purchase Order View</h3>
                        <div className="dashed-line"></div>

                        <table style={{ margin: '1% 5%', fontSize: '15px' }}>

                            <tbody>
                                <tr>
                                    <td style={{ width: '200px' }}>Date</td>

                                    <td style={{ width: '30vw', padding: '0.2% 1.5%' }} className='light-color'>{formData.date}</td>
                                    <td style={{ width: '200px', paddingLeft: '2%' }}>PO No.</td>

                                    <td style={{ padding: '0.2% 1%', width: '150px' }} className='dark-color'>{formData.poNo}</td>
                                </tr>

                                {/* <tr>
                                    <td style={{ width: '200px' }}>Order Type</td>

                                    <td style={{ width: '25vw', padding: '0.2% 1.5%' }} className='light-color'>{formData.ordtype}</td>
                                    {formData.soId != '0' &&
                                        <>
                                            <td style={{ width: '200px' }}>SO No.</td>

                                            <td style={{ width: '25vw', padding: '0 1.5%' }} className='light-color'>{formData.sono}</td>
                                        </>}
                                </tr> */}

                                <tr>
                                    <td style={{ width: '200px' }}>Party</td>

                                    <td style={{ width: '25vw', padding: '0.2% 1.5%' }} className='light-color'>{formData.partyNm}</td>
                                    <td style={{ width: '200px' }}>Firm</td>

                                    <td style={{ width: '25vw', padding: '0 1.5%' }} className='light-color'>{formData.firmNm}</td>
                                </tr>


                                <tr>
                                    <td style={{ width: '200px' }}>Total Qty/Mtr</td>

                                    <td style={{ padding: '0.2% 1.5%' }}>{formData.tot_mtr}</td>
                                    <td style={{ width: '200px' }}>Amount</td>

                                    <td style={{ padding: '0.2% 1.5%' }}>{formData.amt}</td>
                                </tr>

                                <tr>
                                    <td style={{ width: '200px' }}>Tax Amount</td>

                                    <td style={{ padding: '0.2% 1.5%' }}>{formData.taxAmt}</td>
                                    <td style={{ width: '200px' }}>Final Amount</td>

                                    <td style={{ padding: '0.2% 1.5%' }}>{formData.finalAmt}</td>
                                </tr>

                                <tr>
                                    <td style={{ width: '200px' }}>Shift To</td>

                                    <td style={{ padding: '0.2% 1.5%' }}>{formData.shiftTo}</td>
                                    <td style={{ width: '200px' }}>Reference</td>

                                    <td style={{ padding: '0.2% 1.5%' }}>{formData.reference}</td>
                                </tr>

                            </tbody>
                        </table>


                        <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Sr.No.</TableCell>
                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Cloth</TableCell>
                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Delivery Date</TableCell>
                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Rate</TableCell>
                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Meter/KG</TableCell>
                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>Amount</TableCell>
                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>IGST(%)</TableCell>
                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>IGSTAmt</TableCell>
                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>CGST(%)</TableCell>
                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>CGSTAmt</TableCell>
                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>SGST(%)</TableCell>
                                        <TableCell className='th4' sx={{ p: 0.4, border: '1px solid #000' }} align='center'>SGSTAmt</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {polist?.info?.map((row, index) => (
                                        <TableRow key={index}>

                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                {index + 1}
                                            </TableCell>
                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                {row.cloth}
                                            </TableCell>
                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                {row.delivery_date}
                                            </TableCell>
                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                {row.rate}
                                            </TableCell>
                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                {row.mtr}
                                            </TableCell>
                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                {row.Amount}
                                            </TableCell>
                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                {row.igst}
                                            </TableCell>
                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                {row.igstAmt}
                                            </TableCell>
                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                {row.cgst}
                                            </TableCell>
                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                {row.cgstAmt}
                                            </TableCell>
                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                {row.sgst}
                                            </TableCell>
                                            <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                {row.sgstAmt}
                                            </TableCell>

                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>


                    </div>
                    <div style={{ margin: '2% 5%', paddingBottom: '2%' }}>
                        <ReactToPrint
                            trigger={() => <Button variant="contained" color="primary">Print</Button>}
                            content={() => componentRef.current}
                        />
                    </div>

                </Paper>
            </Grid>
        </>
    );
};

export default PurchaseOrdView;
